import config from "@/config";
import { AppPlatform } from "@/constants";
import { getMixpanelDistinctId } from "@/utils/mixpanel";
import { getSearchParamsObject } from "@/utils/url";
import { enrichDefaultCampaignData } from "@/utils/campaign";
const createExtendedHeaders = (appPlatform = "", headers = {}) => {
	const extendedHeaders = {
		app_version: config.version.path,
		app_platform: appPlatform,
		Authorization: headers.Authorization || "",
		"X-Amz-Apigw-Id": headers["X-Amzn-Trace-Id"] || "",
		"X-Amzn-Requestid": headers["X-Amzn-Requestid"] || "",
		"X-Amzn-Trace-Id": headers["X-Amz-Apigw-Id"] || "",
		"X-User-Ip-Address": headers["X-User-Ip-Address"] || "",
		"reflected-user-agent": headers["user-agent"] || "",
		"reflected-ip": headers["x-forwarded-for"] || "",
		"reflected-country": headers["ip-country"] || "",
		"reflected-real-ip": headers["x-real-ip"] || "",
	};

	return extendedHeaders;
};

export const getGlutenFreeTopTenData = async (
	{ topicName, tagAndArea },
	headers = {}
) => {
	const url = new URL(
		`${config.api.address}/atly/top-pages-by-topic/${topicName}`
	);
	url.searchParams.append("tag_and_area", tagAndArea);
	url.searchParams.append("with_steps_list", "false");

	const result = await fetch(url.toString(), {
		headers: createExtendedHeaders(AppPlatform.TT, headers),
	});

	return await result.json();
};

export const getTopTenStepsList = async (
	topTenId,
	{ cursor, limit = 20 },
	headers = {}
) => {
	const query = { limit };
	if (cursor) query.cursor = cursor;
	const queryString = Object.entries(query)
		.map(([key, value]) => `${key}=${value}`)
		.join("&");
	const url = `${config.api.address}/top-steps/${topTenId}/steps?${queryString}`;
	const result = await fetch(url, {
		headers: createExtendedHeaders(AppPlatform.TT, headers),
	});

	return await result.json();
};

const IOS_SUBSCRIPTION_ID = 'gluten.free.eats.2';
const ANDROID_SUBSCRIPTION_ID = 'gluten.free.eats.2';

export const createBranchLink = async ({
	id,
	branchData,
	referringLinkUrl = "",
	isAuth = false,
	authToken,
	userId,
	reason = "tt",
	withSale = false,
}) => {
	const mapId = process.env.NEXT_PUBLIC_STAGE === "prod" ? "CwX3l0tJjXE" : "icb99tZqvAz";
	const pathname = isAuth ? "/branch-links" : "/autls/branch-links";
	const url = encodeURI(config.api.address + pathname);
	const userDistinctId = getMixpanelDistinctId();
	const queryParamsObject = getSearchParamsObject();

	const result = await fetch(url, {
		method: "POST",
		headers: createExtendedHeaders(AppPlatform.TT, isAuth ? {
			Authorization: `Bearer ${authToken}`,
		} : {}),
		body: JSON.stringify({
			reason,
			get_login_token: isAuth,
			campaign: queryParamsObject["~campaign"] || branchData["~campaign"] || "organic_seo",
			// REMARK (Eliran): Snir should talk w Uriel regarding this:
			// utm_campaign: queryParamsObject["utm_campaign"] || branchData["utm_campaign"] || "organic_seo",
			stage: queryParamsObject["~stage"] || branchData["~stage"] || "",
			client_type: id ? "top_ten" : "landing_page",
			link_type: "map_store",
			use_mixpanel_merge: true,
			referring_link_url: referringLinkUrl || branchData.referring_link || "",
			...(id ? { in_product_share_method: "TOP_TEN_PAGE", from_topten_id: id } : {}),
			distinct_id: userDistinctId || "",
			channel:
				branchData["~channel"] || document.referrer.includes(".google.")
					? "google"
					: "unknown",
			data: {
				map_id: mapId,
				user_id: userId,
				conversion_tool: "Direct",
				product: id ? "TopTen" : "LandingPage",
				user_source: "google_organic_tt",
				...(withSale ? {
					android_subscription_id: ANDROID_SUBSCRIPTION_ID,
					ios_subscription_id: IOS_SUBSCRIPTION_ID,
				} : {}),
				...queryParamsObject,
			},
			...enrichDefaultCampaignData(queryParamsObject),
		}),
	});

	const { link } = await result.json();
	return link;
};
